import { useParams } from 'react-router-dom';
import { createRoute, useEntityUrl, UrlParams } from 'framework/routing';
import { ONE_STOP_PATH } from './route';

export const SUPPORT_REQUEST_ID = 'SUP01';
export const CREATE_VENDOR_REQUEST_ID = 'DOC02-NEW';
export const CONTACT_SUPPORT = 'Contact support';
const PREFIX = `/requests`;

export const useOneStopRequestId = () => {
  const urlParams: UrlParams = useParams<Dictionary<string>>();

  return urlParams.id;
};

export const useOneStopRoute = () => {
  const baseRoutes = createRoute({ listRoute: ONE_STOP_PATH, prefix: PREFIX });

  return {
    ...baseRoutes,
  };
};

export const useOneStopRequestsUrl = () => {
  const entityUrl = useEntityUrl({
    baseLink: ONE_STOP_PATH,
  });

  return {
    ...entityUrl,
  };
};

export const useSupportRequestUrl = () => {
  const { getSingleEntityUrl } = useOneStopRequestsUrl();

  return {
    supportUrl: getSingleEntityUrl(SUPPORT_REQUEST_ID),
  };
};

export const useFeedbackRequestUrl = (formId?: string) => {
  const { getSingleEntityUrl } = useOneStopRequestsUrl();

  return {
    supportUrl: getSingleEntityUrl(formId),
  };
};
